export function isQuoteEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1;
}
export function getFormattedQuoteAuthor(author) {
    if (author && author.trim().length > 0) {
        return `— ${author}`;
    }
    return null;
}
